export default ($) => {
    let masonryGrid = $('.js-mObject');

    masonryGrid.masonry({
        itemSelector: '.js-testimonial'
    })
}